module.exports = __webpack_public_path__ + "img/bannerOrange.7635ed3d.jpg";